import { ArrowUpRight, Leaf } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="section-hero"
      className="relative bg-[#1A362B] text-[#F7F5F0] pt-28 md:pt-36 pb-20 md:pb-28 overflow-hidden"
    >
      {/* subtle grain */}
      <div className="absolute inset-0 opacity-[0.08] bg-grain pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Left text */}
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-[#F7F5F0]/70 border border-[#F7F5F0]/20 rounded-full px-3.5 py-1.5 mb-8">
            <Leaf size={13} className="text-[#C4A67B]" />
            Skonsam ytservice
          </div>

          <h1
            data-testid="hero-h1"
            className="font-serif-display text-[44px] sm:text-6xl lg:text-[72px] leading-[1.04] tracking-tight text-balance"
          >
            Skonsam ytservice för{" "}
            <span className="text-[#C4A67B] font-extrabold">tak och fasad</span>.
          </h1>

          <p className="mt-7 max-w-xl text-[#F7F5F0]/75 text-base md:text-lg leading-relaxed">
            Vi hjälper kunder att ta hand om tak och fasader med noggrant arbete,
            varsamma metoder och tydlig återkoppling — så att ytorna bevaras väl
            över tid.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a
              href="#kontakt"
              data-testid="btn-hero-quote"
              className="inline-flex items-center gap-2 bg-[#F7F5F0] text-[#1A362B] hover:bg-[#EAE5D9] rounded-full px-6 py-3.5 font-medium transition-colors"
            >
              Begär offert
              <ArrowUpRight size={18} />
            </a>
            <a
              href="#tjanster"
              data-testid="btn-hero-contact"
              className="inline-flex items-center gap-2 border border-[#F7F5F0]/30 text-[#F7F5F0] hover:bg-[#F7F5F0]/10 rounded-full px-6 py-3.5 font-medium transition-colors"
            >
              Se vad vi gör
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 max-w-md gap-6 text-[#F7F5F0]/85 text-sm">
            <div>
              <div className="font-serif-display text-2xl md:text-3xl text-[#F7F5F0]">01</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-[#F7F5F0]/55">Skonsamt</div>
            </div>
            <div>
              <div className="font-serif-display text-2xl md:text-3xl text-[#F7F5F0]">02</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-[#F7F5F0]/55">Noggrant</div>
            </div>
            <div>
              <div className="font-serif-display text-2xl md:text-3xl text-[#F7F5F0]">03</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-[#F7F5F0]/55">Tydligt</div>
            </div>
          </div>
        </div>

        {/* Right image */}
        <div className="lg:col-span-5 relative">
          <div className="relative rounded-[20px] overflow-hidden shadow-[0_24px_60px_rgba(0,0,0,0.35)] aspect-[4/5] lg:aspect-[3/4]">
            <img
              src="https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxjbGVhbmluZyUyMHJvb2YlMjB3b3JrZXJ8ZW58MHx8fHwxNzc5NDQ4NDY2fDA&ixlib=rb-4.1.0&q=85"
              alt="Hantverkare som arbetar skonsamt på ett tak"
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A362B]/40 via-transparent to-transparent" />
            {/* Floating badge */}
            <div className="absolute left-4 bottom-4 right-4 sm:left-5 sm:bottom-5 sm:right-auto bg-[#F7F5F0]/95 backdrop-blur-sm rounded-2xl p-4 sm:p-5 max-w-xs">
              <div className="flex items-start gap-3">
                <div className="shrink-0 w-9 h-9 rounded-full bg-[#1A362B] flex items-center justify-center">
                  <Leaf size={16} className="text-[#F7F5F0]" />
                </div>
                <div>
                  <div className="text-[11px] uppercase tracking-[0.18em] text-[#5C6B64]">Vårt fokus</div>
                  <div className="mt-1 text-[#1F2321] font-serif-display text-lg leading-tight">
                    Skonsamma metoder framför hårda kemikalier
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
